/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".create-video-request[_ngcontent-%COMP%]   div.checkbox[_ngcontent-%COMP%]{display:inline-block;padding-right:20px}.create-video-request[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]:last-child{margin-bottom:0}.create-video-request[_ngcontent-%COMP%]   .panel-body[_ngcontent-%COMP%]{padding:20px}.invalid-feedback[_ngcontent-%COMP%]{color:#dc3545}\n/*# sourceMappingURL=create-video-request.component.css.map*/"];
export { styles as styles };
